import React, { useState } from 'react';
import { Container, FloatingLabel, Form, InputGroup } from 'react-bootstrap';
import { AiOutlineMail, AiOutlineUnlock, AiOutlineUser } from 'react-icons/ai';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-hot-toast';
import { useEffect } from 'react';
import Loader from '../common/Loader';
import { clearErrors, createProduct } from '../../redux/actions/productAction';
import MetaData from '../MetaData';
import SectionHeading from '../common/SectionHeading';
import { Row, Col } from 'react-bootstrap';
import Sidebar from './Sidebar';
import Select from 'react-select';
import categoryList from '../../constants/category.json';
import { NEW_PRODUCT_RESET } from '../../redux/constants/productConstants';

const CreateProduct = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const categoryOptions = categoryList.map((data) => {
        return {
            value: data,
            label: data,
        };
    });
    const { loading, product, success, error } = useSelector((state) => state.newProduct);
    const [productDetails, setProductDetails] = useState({
        name: '',
        price: 0,
        description: '',
        Stock: 0,
    });
    const [category, setCategory] = useState(categoryOptions[0]);
    const [productImages, setProductImages] = useState([]);
    const [imagesPreview, setImagesPreview] = useState([]);

    useEffect(() => {
        if (error) {
            toast.error(error);
            dispatch(clearErrors());
        }
        if (success) {
            toast.success('Product created successfully');
            navigate('/admin/dashboard');
            dispatch({ type: NEW_PRODUCT_RESET });
        }
    }, [error, success, dispatch]);

    const handleSubmit = (e) => {
        e.preventDefault();
        dispatch(
            createProduct({ ...productDetails, category: category.label, images: productImages })
        );
    };

    const handleInputChange = (e) => {
        setProductDetails({ ...productDetails, [e.target.name]: e.target.value });
    };

    const createProductImagesChange = (e) => {
        const files = Array.from(e.target.files);

        setProductImages([]);
        setImagesPreview([]);

        files.forEach((file) => {
            const reader = new FileReader();

            reader.onload = (e) => {
                if (reader.readyState === 2) {
                    setProductImages((old) => [...old, reader.result]);
                    setImagesPreview((old) => [...old, reader.result]);
                }
            };

            reader.readAsDataURL(file);
        });
    };

    return loading ? (
        <Loader />
    ) : (
        <>
            <MetaData title={'Create Product'} />
            <Container>
                <div className='myOrdersPage section-padding-top section-padding-bottom'>
                    <Row>
                        <Col md={3}>
                            <Sidebar />
                        </Col>
                        <Col md={9}>
                            <form onSubmit={handleSubmit} className='createProductForm'>
                                <h4 className='text-center mb-4'>Create Product</h4>
                                <InputGroup className='mb-3'>
                                    <InputGroup.Text id='basic-addon1'>
                                        <AiOutlineUser />
                                    </InputGroup.Text>
                                    <Form.Control
                                        placeholder='Name'
                                        aria-label='Name'
                                        name='name'
                                        type='text'
                                        value={productDetails.name}
                                        onChange={handleInputChange}
                                    />
                                </InputGroup>
                                <InputGroup className='mb-3'>
                                    <InputGroup.Text id='basic-addon1'>
                                        <AiOutlineMail />
                                    </InputGroup.Text>
                                    <Form.Control
                                        placeholder='Price'
                                        aria-label='Price'
                                        name='price'
                                        type='number'
                                        min={0}
                                        value={productDetails.price}
                                        onChange={handleInputChange}
                                    />
                                </InputGroup>
                                <FloatingLabel
                                    controlId='floatingTextarea2'
                                    label='Description'
                                    className='mb-3'
                                >
                                    <Form.Control
                                        as='textarea'
                                        name='description'
                                        placeholder='Product Description'
                                        style={{ height: '100px' }}
                                        value={productDetails.description}
                                        onChange={handleInputChange}
                                    />
                                </FloatingLabel>
                                <InputGroup className='select-group mb-3'>
                                    <InputGroup.Text id='basic-addon1'>
                                        <AiOutlineUser />
                                    </InputGroup.Text>
                                    <Select
                                        className='custom-select'
                                        value={category}
                                        onChange={(e) => setCategory(e)}
                                        options={categoryOptions}
                                    />
                                </InputGroup>
                                <InputGroup className='mb-3'>
                                    <InputGroup.Text id='basic-addon1'>
                                        <AiOutlineMail />
                                    </InputGroup.Text>
                                    <Form.Control
                                        placeholder='Stock'
                                        aria-label='Stock'
                                        name='Stock'
                                        type='number'
                                        min={1}
                                        value={productDetails.Stock}
                                        onChange={handleInputChange}
                                    />
                                </InputGroup>
                                <div className='my-3'>
                                    <div className='registerImg'>
                                        <input
                                            type='file'
                                            accept='image/'
                                            multiple
                                            onChange={createProductImagesChange}
                                        />
                                    </div>
                                    <div className='d-flex justify-content-center mt-3'>
                                        {productImages.map((image, i) => (
                                            <div key={i} className='product-img-preview'>
                                                <img src={image} alt='Product' />
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <input
                                    type='submit'
                                    value='Create'
                                    className='submitBtn'
                                    disabled={loading ? true : false}
                                />
                            </form>
                        </Col>
                    </Row>
                </div>
            </Container>
        </>
    );
};

export default CreateProduct;
